export default `
... on pageBlocks_gridItemRandomLetter_BlockType {
  gridItemType: __typename
  uid
  baseColorpicker
  baseBlockSize
}
`;
